import { Component, inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { EMPTY, catchError, map, mergeMap, shareReplay, startWith } from 'rxjs';
import { NgClass, AsyncPipe } from '@angular/common';

import { Page, SafeHtmlPipe, ServerResponseService, StoreService } from '@speedy/core';
import { BreadcrumbsComponent } from '../../../shared';

@Component({
  standalone: true,
  selector: 'app-page',
  templateUrl: './page.component.html',
  styleUrls: ['./page.component.scss'],
  imports: [NgClass, AsyncPipe, BreadcrumbsComponent, SafeHtmlPipe],
})
export class PageComponent {
  private readonly route = inject(ActivatedRoute);
  private readonly serverResponseService = inject(ServerResponseService);
  private readonly storeService = inject(StoreService);

  page$ = this.storeService.store$.pipe(
    startWith({}),
    mergeMap(() => {
      return this.route.data.pipe(
        map((data) => data.page as Page),
        catchError((error) => {
          console.error(error);
          this.serverResponseService.setNotFound();
          return EMPTY;
        }),
        shareReplay(1),
      );
    }),
  );
}
